import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=7283a0c8&scoped=true&"
import script from "./Arrow.vue?vue&type=script&lang=js&"
export * from "./Arrow.vue?vue&type=script&lang=js&"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=7283a0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7283a0c8",
  null
  
)

component.options.__file = "Arrow.vue"
export default component.exports